// local
import Api from '.';

export function oxigenByPatient() {
    return Api.get('/monitor/oxigen-by-patient');
}

export function addRestitution(id) {
    return Api.post(`/monitor/add-restitution/${id}`);
}

export function removeRestitution(id) {
    return Api.post(`/monitor/remove-restitution/${id}`);
}

export function updatePrescription(id, data) {
    return Api.post(`/monitor/update-prescription/${id}`, data);
}
